/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react';
import { useMutation, useQuery, useSubscription } from '@apollo/client';
import {
  BehaviourProvider,
  OperationDetail,
} from '@facephi/inphinite-behaviour-module';
import {
  Anonymized,
  Asset,
  DetailHeader,
  EntityStatus,
  FacialAuthenticationStatus,
  Map,
  NoFilesUploaded,
  OcrData,
  Operation,
  OperationResult,
  OperationResultReason,
  SCOPES,
  StepsFilter,
  TrackingFamily,
  VerificationStatusValues,
  getOperation,
  useAnonymize,
  useArrayNavigation,
  useCommon,
  useFlags,
  usePermissions,
  FacialLivenessDiagnostic,
} from '@facephi/inphinite-common';
import {
  Button,
  ButtonIcon,
  CardBase,
  CardBaseHeader,
  Dropdown,
  DropdownOption,
  FlexContainer,
  Icon,
  Label,
  setColorTheme,
  TabPanel,
  useToast,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import {
  DetailError,
  DropdownFilesCard,
  StatusCard,
  ModalOperationsDetail,
  OperationCardElement,
  OperationCardOCR,
  OperationCardTimeline,
  OperationContainer,
  OperationContentAnonymized,
  OperationFaceContent,
  OperationTimeline,
  OperationTimelineWrapper,
  OperationsCard,
  OperationsCardDevice,
  OperationsCardDocuments,
  OperationsCardFiles,
  OperationsCardIcon,
  OperationsCardStatus,
  OperationsContentDevice,
  OperationsDataContent,
  OperationsDocumentCard,
  OperationsEmptyData,
  OperationsFileCard,
  OperationsFilesColumn,
  OperationsSecurityTab,
  OperationsTabs,
  OperationsTabsContent,
  ReactSimpleMapsStyles,
  ReviewCard,
  ReviewForm,
  ReviewTimeline,
  ReviewsDataContent,
  SelfieValidations,
  FingerprintValidation,
  Nationality,
  OcrDetail,
  VoiceValidation,
  OperationSelfieCardElement,
  OperationCardFacialData,
  OperationFacialDetailsWrapper,
  StatusContainer,
} from '../components';
import {
  CustomDropdownAsset,
  FacialValidationState,
  FingerprintValidationState,
  fingersNames,
} from '../components/operations/model';
import { DetailFacial } from '../components/operations/operationsCards/DetailFacial';
import { useOperations } from '../providers';
import {
  FULL_FRAME,
  GovernmentServices,
  BinaryStates,
  SELFIE,
  DOCUMENT_FACIAL_CAPTURE,
  personalInformation,
  DEMO_BE_SOURCE,
} from '../state/constants';
import {
  OperationResultDto,
  OperationStatus,
  OperationSecurityResult,
  StatusChange,
  facialBlackList,
  OperationResultReason as OperationReasons,
  ignoredValidations,
} from '../state/model';
import { generateOnboardingReport } from '../state/mutations';
import { updateOperationDetails } from '../state/subscriptions';

const FileCard = ({
  index,
  asset,
  anonymized,
  onClick,
  image,
  video,
  audio,
  mimeType,
}: {
  index: number;
  asset: Asset;
  anonymized?: boolean;
  onClick: (position: number) => void;
  image: boolean;
  video?: boolean;
  audio?: boolean;
  mimeType?: string;
}) => {
  const hasError = false;
  return (
    <OperationsFileCard
      key={index}
      title={asset.type}
      hasError={hasError}
      onClick={() => onClick(index)}
      icon={
        <ButtonIcon
          variant="text"
          size="M"
          iconName={video || audio ? 'Play' : 'MagnifyingGlassPlus'}
          onClick={() => onClick(index)}
          disabled={anonymized || hasError}
        />
      }
      image={image}
      source={asset.url}
      iconLeft={video ? 'VideoCamera' : audio ? 'Microphone' : 'FilePdf'}
      mimeType={asset.contentType}
    />
  );
};

type StateProps = {
  activeTab?: string;
};

type ErrorResults = {
  type: string;
  status?: EntityStatus;
  reason: string;
  decision?: string;
  mode?: string;
};

type IProps = {
  hideReviewTab?: boolean;
  emptyBackRoute: string;
  emptyBackText: string;
  token?: string;
};

type GenerateOnboardingReportResponse = {
  generateOnboardingReport?: {
    asset?: Asset | null;
  } | null;
};

type GeneratedReportType = 'AUDIT_DOCUMENT' | 'SIGNATURE_PROOF';
const REPORTABLE_OPERATION_STATUSES: string[] = [
  EntityStatus.succeeded,
  EntityStatus.denied,
  EntityStatus.expired,
];
const REPORT_GENERATION_STATUS_ERROR =
  'Report generation is only available for SUCCEEDED, DENIED or EXPIRED operations';

const GenerateReportButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    min-width: 12rem;
  }

  .infinite-loading {
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      left: -100%;
      height: 0.4rem;
      background-color: ${setColorTheme('primary400')};
      opacity: 0.75;
      border-radius: 0.8rem;
      animation: load 3s linear infinite;
      width: 100%;
    }
  }

  @keyframes load {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }
`;

export const OperationsIDPage = ({
  hideReviewTab,
  emptyBackRoute,
  emptyBackText,
  token,
}: IProps) => {
  const { demo } = useFlags();
  const { t, i18n } = useTranslation();
  const { anonymized, anonymize } = useAnonymize();
  const { toastManager } = useToast();
  const location = useLocation();
  const { apiUrl, language, role, timezone } = useOperations();
  const { permissionGranted } = usePermissions([SCOPES.canWriteOperations]);
  const { permissionGranted: hasBehaviourPermission } = usePermissions(
    [SCOPES.canViewBehaviour],
    role,
  );
  const hideBehaviour = true; // TO DO delete when behaviour is implemented
  const { permissionGranted: hasAuditPermission } = usePermissions(
    [SCOPES.canViewAudit],
    role,
  );

  const haveReviewTab = useMemo(() => {
    if (hideReviewTab) {
      return false;
    } else {
      if (!hasAuditPermission) {
        return false;
      }
      return true;
    }
  }, [hasAuditPermission]);

  const [operationInProgress, setOperationInProgress] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<string>(
    (location.state as StateProps)?.activeTab || '1',
  );
  const [ocrActive, setOcrActive] = useState<string[] | undefined>();
  const [behaviourEmpty, setBehaviourEmpty] = useState<boolean>(false);
  const [generatedAuditDocument, setGeneratedAuditDocument] =
    useState<Asset | null>(null);
  const [generatedSignatureProof, setGeneratedSignatureProof] =
    useState<Asset | null>(null);
  const [generatingReportType, setGeneratingReportType] =
    useState<GeneratedReportType | null>(null);

  const [facialAuthenticateResult, setFacialAuthenticateResult] =
    useState<FacialValidationState[]>();
  const [fingerprintAuthenticateResult, setFingerprintAuthenticateResult] =
    useState<FingerprintValidationState[]>();

  const {
    tenant: { id: tenantId },
  } = useCommon();
  const { id } = useParams<{ id: string }>() as { id: string };

  const { data, loading } = useQuery(getOperation, {
    variables: { id, tenantId },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });
  const [generateReportMutation, { loading: isGeneratingReport }] =
    useMutation<GenerateOnboardingReportResponse>(generateOnboardingReport);

  useSubscription(updateOperationDetails, {
    variables: { id },
    onSubscriptionData: ({ client, subscriptionData }) => {
      client.writeQuery({
        query: getOperation,
        variables: { id, tenantId },
        data: subscriptionData.data,
      });
    },
  });

  useEffect(() => {
    setGeneratedAuditDocument(null);
    setGeneratedSignatureProof(null);
    setGeneratingReportType(null);
  }, [id]);

  const reasonBlacklisted = useMemo(
    () =>
      data
        ? data.operation.results?.find(
            (result: OperationResultDto) =>
              result.reason && result.status === OperationStatus.blacklisted,
          )
          ? data.operation.results?.find(
              (result: OperationResultDto) =>
                result.reason && result.status === OperationStatus.blacklisted,
            ).reason
          : null
        : null,
    [data],
  );

  const errorSecurity = (errorData: any) =>
    errorData &&
    errorData['verificationStatus'] !== VerificationStatusValues.verified;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getOperationData = (info: any) => {
    return {
      ...info.operation,
      ...info.operation.details,
      reasonBlacklisted,
      securityList: info.operation.details.securityInfoDataList
        ? [...info.operation.details.securityInfoDataList]
        : info.operation.details.securityData
          ? [
              {
                succeed: !errorSecurity(info.operation.details.securityData),
                data: { ...info.operation.details.securityData },
                mode: 'Security',
              },
            ]
          : [],
    };
  };

  const operation: Operation = useMemo(
    () => (data ? getOperationData(data) : { assets: [], currentStep: '' }),
    [data],
  );

  const hasSecurityError: boolean = useMemo(
    () =>
      operation?.securityList && operation?.securityList?.length > 0
        ? operation?.securityList.some((element) => element.succeed === false)
        : false,
    [operation],
  );

  useEffect(() => {
    setOperationInProgress(
      data ? data.operation.status === OperationStatus.started : false,
    );
  }, [data]);

  const logError: Array<ErrorResults> = useMemo(() => {
    return operation?.results || operation?.securityList
      ? [
          ...operation.results?.filter(({ reason }) => reason),
          ...(operation.securityList
            ? (operation.securityList as Array<any>)
                ?.filter((element) => element.succeed === false)
                .map((element) => {
                  return element.source !== 'Antispoof'
                    ? {
                        type: 'security',
                        decision: element?.data.decision,
                        reason:
                          element.mode === 'ANTIFRAUD_CHECK' ||
                          element.mode === 'PREVIOUS_ONBOARDINGS_CHECK'
                            ? element.mode
                            : element?.data.reason,
                        mode: element?.mode,
                      }
                    : {
                        type: 'Antispoof',
                        decision: element?.data.decision,
                        reason: OperationReasons.antispoofingNotPassed,
                      };
                })
            : []),
        ]
      : [];
  }, [operation]);

  const noHaveResults = useMemo(
    () =>
      !loading &&
      operation.family === TrackingFamily.ONBOARDING &&
      !operation.facialAuthenticateResult &&
      !operation.assets?.length &&
      !operation.ocrData?.length &&
      !operation.facialAuthenticateResult &&
      !(operation?.securityList!.length > 0) &&
      !operation.device
        ? true
        : operation.family === TrackingFamily.AUTHENTICATION &&
            !operation.facialAuthenticateResult &&
            !operation.assets?.length &&
            !operation.ocrData?.length &&
            !operation.facialAuthenticateResult &&
            !(operation?.securityList!.length > 0) &&
            !operation.device
          ? true
          : false,

    [loading, operation],
  );

  const documents: Asset[] = useMemo(() => {
    if (!operation) {
      return [];
    }

    const operationAssets = operation.assets as Asset[];
    const generatedReportAssets = [
      generatedAuditDocument,
      generatedSignatureProof,
    ].filter((asset): asset is Asset => asset !== null);

    return [...operationAssets, ...generatedReportAssets].filter(
      (element, index, allAssets) =>
        !element.type.includes('WSQ') &&
        allAssets.findIndex(({ type }) => type === element.type) === index,
    );
  }, [generatedAuditDocument, generatedSignatureProof, operation]);

  const facialDetailsData: Asset[] = useMemo(
    () =>
      documents.filter(
        (element) => element.type === 'SELFIE' && element.characteristics,
      ),
    [documents],
  );

  const otherTypesOCR: Operation['ocrData'] = useMemo(
    () =>
      operation.ocrData?.length > 1
        ? operation.ocrData?.filter((data) => data.source !== DEMO_BE_SOURCE)
        : [],
    [operation],
  );

  const ocrDropdown: DropdownOption[] = useMemo(
    () =>
      operation.ocrData?.map((data) => ({
        name: data.source,
        value: data.source,
      })) || [],
    [operation],
  );

  const ocrData = useMemo(
    () =>
      operation.ocrData?.length
        ? operation.ocrData?.find((data) => data.source === DEMO_BE_SOURCE) ||
          operation.ocrData?.[0]
        : ({} as OcrData),
    [operation],
  );

  useEffect(() => {
    if (activeTab === '3') {
      !ocrDetailData?.dataSerialized && setOcrActive([ocrData.source]);
    }
  }, [activeTab]);

  const facialDetailsPersonalData: any = useMemo(() => {
    if (data?.operation?.details?.ocrData) {
      const info = data.operation.details.ocrData?.find(
        (element: any) => element.default,
      );

      return {
        name: info?.personalInformation.name,
        surname: info?.personalInformation.surname,
        nationality: info?.personalInformation.nationality,
        birthDate: info?.personalInformation?.birthDate,
      };
    }
  }, [data]);

  const isAuthentication: boolean = useMemo(
    () => operation.family === TrackingFamily.AUTHENTICATION,
    [operation],
  );

  const showSecurityTab = useMemo(
    () =>
      !isAuthentication ||
      Boolean(operation?.securityList && operation.securityList.length > 0),
    [isAuthentication, operation?.securityList],
  );

  const auditDocumentAsset = useMemo(
    () => documents.find(({ type }) => type === 'AUDIT_DOCUMENT'),
    [documents],
  );

  const signatureProofAsset = useMemo(
    () => documents.find(({ type }) => type === 'SIGNATURE_PROOF'),
    [documents],
  );

  const hasSignatureSelfieAsset = useMemo(
    () => operation.assets?.some(({ type }) => type === 'SIGNATURE_SELFIE'),
    [operation],
  );

  const canGenerateReports = useMemo(
    () => REPORTABLE_OPERATION_STATUSES.includes(operation.status),
    [operation.status],
  );

  const pdfDocuments = useMemo(
    () =>
      documents.filter(
        ({ contentType, type }) =>
          contentType.includes('pdf') && !type.includes(FULL_FRAME),
      ),
    [documents],
  );

  const [position, setPotision, { prev, next, itemSelected }] =
    useArrayNavigation<Asset>(documents);

  const operationDisplayStatus = operation.status;

  const OperationsHeaderPanel = () => {
    return (
      <DetailHeader
        id={operation.operationId}
        date={operation.lastUpdateTime}
        currentStep={operation.currentStep}
        status={operationDisplayStatus}
        loading={loading}
        family={operation.family}
        locale={language}
      />
    );
  };

  /*

  TODO: uncomment this and delete the implementation below when we receive the corresponding assets
  */
  const facialAuthResultsIds: FacialValidationState[] | undefined = useMemo(
    () =>
      operation.facialAuthenticateResult?.map((result) => ({
        ...result,
        id: uuidv4(),
      })),
    [operation],
  );

  const renderFacialResultListDropdown = () => {
    const changeHandler = (provider: string) => {
      const selectedProvider = facialAuthResultsIds?.find(
        (option) => option.id === provider,
      );
      selectedProvider && setFacialAuthenticateResult([selectedProvider]);
    };

    if (facialAuthResultsIds && facialAuthResultsIds?.length >= 2) {
      const dropdownOptions = facialAuthResultsIds?.map((option) => {
        return {
          name: option.source,
          value: option.id,
        };
      });

      return (
        <Dropdown
          options={dropdownOptions}
          onChange={changeHandler}
          placeholder={facialAuthResultsIds[0].source}
        />
      );
    }
  };

  const fingerprintAuthResultsIds: FingerprintValidationState[] | undefined =
    useMemo(
      () =>
        operation.fingerprintAuthenticateResultList
          ?.slice()
          .sort((a, b) => a.index - b.index)
          .map((result) => ({
            ...result,
            id: uuidv4(),
          })),
      [operation],
    );

  const renderFingerprintResultListDropdown = () => {
    const changeHandler = (provider: string) => {
      const selectedProvider = fingerprintAuthResultsIds?.find(
        (option) => option.id === provider,
      );
      selectedProvider && setFingerprintAuthenticateResult([selectedProvider]);
    };

    if (fingerprintAuthResultsIds && fingerprintAuthResultsIds.length >= 2) {
      const dropdownOptions = fingerprintAuthResultsIds.map((option) => ({
        name: `${t(fingersNames[option.index])}`,
        value: option.id,
      }));

      return (
        <Dropdown
          options={dropdownOptions}
          onChange={changeHandler}
          value={fingerprintAuthResultsIds[0].id}
        />
      );
    }
  };

  useEffect(() => {
    if (facialAuthResultsIds?.length)
      setFacialAuthenticateResult([facialAuthResultsIds[0]]);
  }, [operation]);

  useEffect(() => {
    if (fingerprintAuthResultsIds?.length)
      setFingerprintAuthenticateResult([fingerprintAuthResultsIds[0]]);
  }, [operation]);

  const getInfoPostion = () =>
    position !== null ? `${position + 1}/${documents.length}` : '';

  const getLoadingDocuments = () =>
    Array.from({ length: 6 }).map((_, index) => (
      <OperationsCard
        title={' '}
        key={index}
        loading={true}
        icon={
          <ButtonIcon variant="text" size="S" iconName="MagnifyingGlassPlus" />
        }
      >
        <Skeleton height={70} width={70} borderRadius={8} />
      </OperationsCard>
    ));

  const checkAvailableElements = (type: string) =>
    documents.filter((el) => el.contentType.includes(type)).length !== 0;

  const getElementsByType = (type: string): CustomDropdownAsset[] =>
    documents
      .filter((document) => document.contentType.includes(type))
      .map((file) => ({
        type: file.type,
        url: file.url,
        contentType: file.contentType,
        position: documents.findIndex((document) => document.url === file.url),
      }));

  const getDocuments = (type: string) => {
    if (type === 'video' || type === 'audio') {
      const elementsBytype = getElementsByType(type);
      if (elementsBytype.length > 2) {
        return (
          <DropdownFilesCard
            assets={elementsBytype}
            onClick={setPotision}
            contentType={type}
            loading={loading}
          />
        );
      }
    }
    return documents.length && checkAvailableElements(type) ? (
      documents.map(
        (item, index) =>
          item.contentType.includes(type) &&
          !item.type.includes(FULL_FRAME) && (
            <FileCard
              key={index}
              asset={item}
              index={index}
              onClick={setPotision}
              anonymized={anonymized}
              video={type === 'video'}
              image={type === 'image'}
              audio={type === 'audio'}
            />
          ),
      )
    ) : (
      <NoFilesUploaded document={true} locale={language} />
    );
  };

  const getErrorMessage = (error: unknown) => {
    const apolloError = error as {
      graphQLErrors?: Array<{ message?: string }>;
      networkError?: { message?: string };
      message?: string;
    };

    return (
      apolloError?.graphQLErrors?.find(({ message }) => message)?.message ||
      apolloError?.networkError?.message ||
      apolloError?.message ||
      'Unexpected error'
    );
  };

  const handleGenerateReport = async (reportType: GeneratedReportType) => {
    if (isGeneratingReport) {
      return;
    }

    try {
      const operationData = operation as Operation;

      if (!operationData?.operationId) {
        throw new Error('Operation details are required');
      }

      if (!canGenerateReports) {
        throw new Error(REPORT_GENERATION_STATUS_ERROR);
      }

      setGeneratingReportType(reportType);

      const response = await generateReportMutation({
        variables: {
          input: {
            reportType,
            operationId: operationData.operationId || id,
            status: operationData.status,
          },
        },
      });

      const generatedAsset = response.data?.generateOnboardingReport?.asset;

      if (!generatedAsset) {
        throw new Error('Unexpected error');
      }

      if (reportType === 'SIGNATURE_PROOF') {
        setGeneratedSignatureProof(generatedAsset);
      } else {
        setGeneratedAuditDocument(generatedAsset);
      }
    } catch (error) {
      toastManager({
        type: 'error',
        message: getErrorMessage(error),
        canClose: true,
      });
    } finally {
      setGeneratingReportType(null);
    }
  };

  const getGenerateReportButton = (
    reportType: GeneratedReportType,
    title: string,
    testId: string,
  ) => (
    <OperationsFileCard
      key={reportType}
      title={title}
      hasError={false}
      source=""
      iconLeft="FilePdf"
      icon={
        <GenerateReportButtonWrapper>
          <Button
            onClick={() => handleGenerateReport(reportType)}
            disabled={isGeneratingReport}
            testId={testId}
            color="primary"
            iconName="Files"
            className={
              isGeneratingReport && generatingReportType === reportType
                ? 'infinite-loading'
                : ''
            }
          >
            {t('Generate')}
          </Button>
        </GenerateReportButtonWrapper>
      }
    />
  );

  const getDocumentsCardContent = () => {
    const reportButtons = [
      canGenerateReports && !auditDocumentAsset
        ? getGenerateReportButton(
            'AUDIT_DOCUMENT',
            t('AUDIT_DOCUMENT'),
            'generate-report-button',
          )
        : null,
      canGenerateReports && hasSignatureSelfieAsset && !signatureProofAsset
        ? getGenerateReportButton(
            'SIGNATURE_PROOF',
            t('SIGNATURE_PROOF'),
            'generate-signature-proof-button',
          )
        : null,
    ].filter(Boolean);

    if (!reportButtons.length) {
      return getDocuments('pdf');
    }

    return (
      <>
        {pdfDocuments.length > 0 && getDocuments('pdf')}
        {reportButtons}
      </>
    );
  };

  const getDocumentsCard = () => (
    <OperationsCardDocuments title={t('Documents')} loading={loading}>
      <OperationsDocumentCard disabled={anonymized} rowGap="1">
        {loading ? getLoadingDocuments() : getDocumentsCardContent()}
      </OperationsDocumentCard>
    </OperationsCardDocuments>
  );

  const getImageCards = (elements: any[]) => {
    if (!elements.some((list) => list.elements.length > 0))
      return <NoFilesUploaded document={true} locale={language} />;

    return (
      <>
        {elements.map((list: any, idx: number) => {
          if (list.elements.length > 1) {
            const type = list.type;
            return (
              <DropdownFilesCard
                key={idx}
                assets={list.elements}
                onClick={setPotision}
                contentType={type}
                loading={loading}
              />
            );
          }

          return (
            list.elements.length === 1 &&
            list.elements.map(
              (item: any, index: number) =>
                item.contentType.includes('image') &&
                !item.type.includes(FULL_FRAME) && (
                  <FileCard
                    key={index}
                    asset={item}
                    index={item.position}
                    onClick={setPotision}
                    anonymized={anonymized}
                    video={false}
                    image={true}
                    audio={false}
                  />
                ),
            )
          );
        })}
      </>
    );
  };

  const getImages = () => {
    const imageElements = getElementsByType('image');
    const documentElements = imageElements.filter((element) =>
      element.type.includes('DOCUMENT_'),
    );
    const photoElements = imageElements.filter(
      (element) =>
        !element.type.includes('SIGNATURE') &&
        (element.type.includes('SELFIE') || element.type.includes('NFC_PHOTO')),
    );
    const fingerPrintElements = imageElements.filter(
      (element) =>
        element.type.includes('PHINGER_') ||
        element.type.includes('FINGERPRINT'),
    );
    const signatureElements = imageElements.filter((element) =>
      element.type.includes('SIGNATURE'),
    );

    const uploaderElements = imageElements.filter((element) =>
      element.type.includes('FILE_UPLOADER_ASSET'),
    );

    return getImageCards([
      { elements: [...documentElements], type: 'image' },
      { elements: [...photoElements], type: 'photo' },
      { elements: [...fingerPrintElements], type: 'fingerprint' },
      { elements: [...signatureElements], type: 'signature' },
      { elements: [...uploaderElements], type: 'uploader' },
    ]);
  };

  const getLoadingMap = () => (
    <>
      <Skeleton height={200} borderRadius={8} />
      <FlexContainer
        flexDirection="column"
        rowGap="0.8"
        style={{ marginTop: '3rem' }}
      >
        <Skeleton height={18} width="35%" borderRadius={8} />
        <Skeleton height={18} width="50%" borderRadius={8} />
      </FlexContainer>
    </>
  );

  const countryVsLocationNotPassed: boolean = useMemo(
    () =>
      operation.results?.some(
        (result) =>
          result.reason ===
          OperationReasons.countryVsLocationNotPAssed.toString(),
      ),
    [operation],
  );

  const getMap = () => (
    <>
      <ReactSimpleMapsStyles>
        <Map
          markers={
            operation.coordinates
              ? [
                  {
                    lat: operation.coordinates.latitude,
                    lng: operation.coordinates.longitude,
                    name: 'marker',
                  },
                ]
              : undefined
          }
        />
      </ReactSimpleMapsStyles>
      {!isAuthentication &&
        nationalityVsGeolocationResultObject?.length > 0 && (
          <FlexContainer flexDirection="column" rowGap="0.8">
            <Nationality
              loading={loading}
              result={
                !loading &&
                nationalityVsGeolocationResult === BinaryStates.success
                  ? true
                  : false
              }
            />
          </FlexContainer>
        )}
    </>
  );

  const checkNfcWidget: boolean = useMemo(
    () =>
      operation.steps?.includes(StepsFilter.NFC_WIDGET) &&
      !operation.results?.some(
        (result) => result.reason === OperationResultReason.nfcInternalError,
      ),
    [operation],
  );

  const checkLivenessError: boolean = useMemo(
    () =>
      Boolean(operation.facialAuthenticateResult?.length) &&
      operation.facialAuthenticateResult?.[0]?.authStatus !==
        FacialAuthenticationStatus.positive,
    [operation],
  );

  const checkLivenessData: boolean = useMemo(
    () =>
      Boolean(operation?.facialLivenessResult) ||
      Boolean(operation?.facialAuthenticateResult?.length),
    [operation],
  );
  const noFacialValidationData: boolean = useMemo(
    () =>
      !operation.assets.find(({ type }) => type === SELFIE) &&
      !operation.assets.find(({ type }) => type === DOCUMENT_FACIAL_CAPTURE) &&
      !operation.ocrData?.[0]?.documentImages.find(
        ({ type }) => type === SELFIE,
      ) &&
      !operation.ocrData?.[0]?.documentImages.find(
        ({ type }) => type === DOCUMENT_FACIAL_CAPTURE,
      ) &&
      !facialAuthenticateResult?.length &&
      !operation.facialLivenessResult,
    [operation],
  );

  const errorOnPersonalInformation = useMemo(
    () =>
      !ocrData ||
      !ocrData.personalInformation ||
      (ocrData.personalInformation &&
        Object.values(ocrData?.personalInformation)
          .filter((item) => item !== personalInformation)
          .every((value) => value === null)),
    [ocrData.personalInformation],
  );

  const livenessResult = useMemo(
    () =>
      operation.facialLivenessResult?.diagnostic ===
      FacialLivenessDiagnostic.live
        ? BinaryStates.success
        : BinaryStates.error,
    [operation.facialLivenessResult],
  );

  const documentSidesResultObject = useMemo(() => {
    if (operation?.securityList) {
      return operation?.securityList.filter(
        (element) => element.mode === 'DOCUMENT_VALIDATION_SIDES',
      );
    }

    return [];
  }, [operation.securityList]);

  const documentSidesResult = useMemo(() => {
    if (documentSidesResultObject)
      return documentSidesResultObject[0]?.data?.result ===
        OperationStatus.succeeded
        ? BinaryStates.success
        : BinaryStates.error;

    return BinaryStates.error;
  }, [documentSidesResultObject]);

  const nfcValidationResultObject = useMemo(() => {
    if (operation?.securityList) {
      return operation?.securityList.filter(
        (element) => element.mode === 'NFC_VERIFICATION',
      );
    }

    return [];
  }, [operation.securityList]);

  const nfcValidationResult = useMemo(() => {
    if (documentSidesResultObject)
      return nfcValidationResultObject[0]?.data?.result ===
        OperationStatus.succeeded
        ? BinaryStates.success
        : BinaryStates.error;

    return BinaryStates.error;
  }, [nfcValidationResultObject]);

  const nationalityVsGeolocationResultObject = useMemo(() => {
    if (operation?.securityList) {
      return operation?.securityList.filter(
        (element) => element.mode === 'NATIONALITY_VS_LOCATION',
      );
    }

    return [];
  }, [operation.securityList]);

  const nationalityVsGeolocationResult = useMemo(() => {
    if (nationalityVsGeolocationResultObject)
      return nationalityVsGeolocationResultObject[0]?.data?.result ===
        OperationStatus.succeeded
        ? BinaryStates.success
        : BinaryStates.error;

    return BinaryStates.error;
  }, [nationalityVsGeolocationResultObject]);

  const spoofingResultObject = useMemo(() => {
    if (operation?.securityList) {
      return operation?.securityList.filter(
        (element) => element.source === 'Antispoof',
      );
    }

    return [];
  }, [operation.securityList]);

  const spoofingResult: BinaryStates = useMemo(() => {
    if (spoofingResultObject)
      return spoofingResultObject[0]?.succeed
        ? BinaryStates.success
        : BinaryStates.error;

    return BinaryStates.error;
  }, [spoofingResultObject]);

  const ocrDetailData: any = useMemo(() => {
    if (Object.entries(ocrData).length > 0) {
      const fields = ocrData.documentDataFields;
      const serialized = fields.find(
        (element) => element.key === 'documentDataFieldsSerialized',
      );
      const countryCode = fields.find(
        (element) => element.key === 'COUNTRY_CODE' || element.key === 'Issuer',
      );
      const docModel = fields.find(
        (element) =>
          element.key === 'DOC_MODEL' || element.key === 'DocumentCaptured',
      );
      return {
        countryCode:
          countryCode?.value || ocrData.personalInformation?.nationality,
        docModel: docModel?.value,
        dataSerialized: serialized?.value,
      };
    }
    return {};
  }, [ocrData, otherTypesOCR]);

  const listOcrElements = (): OcrData[] => {
    if (operation?.ocrData?.length && ocrActive?.length)
      return operation.ocrData.filter((ocr) => ocrActive?.includes(ocr.source));

    return [];
  };

  const getNationalityCard = () => (
    <OperationsCard title={t('Nationality')} loading={loading} icon={null}>
      <OperationFaceContent
        flexDirection="column"
        rowGap="0.8"
        disabled={anonymized}
      >
        {loading ? getLoadingMap() : getMap()}
      </OperationFaceContent>
    </OperationsCard>
  );

  const getDeviceCard = () => (
    <OperationsContentDevice
      flexDirection="column"
      rowGap="0.8"
      $isAuthentication={isAuthentication}
    >
      <OperationsCardDevice title={t('Device information')} loading={loading}>
        <OperationFaceContent
          flexDirection="column"
          justifyContent="space-between"
          disabled={anonymized}
        >
          <div>
            {!loading && !operation.device ? (
              <NoFilesUploaded messageType="information" locale={language} />
            ) : (
              <OperationCardElement
                loading={loading}
                data={{
                  type: operation.device?.type,
                  model: operation.device?.model,
                  OS: operation.device?.osName,
                  osVersion: operation.device?.osVersion,
                  Brand: operation.device?.brand,
                  DeviceID: operation.device?.deviceId,
                  Browser: operation.device?.browser,
                  DeviceType: operation.device?.deviceType,
                  Engine: operation.device?.engine,
                  isRooted: operation.device?.isRooted,
                  isEmulated: operation.device?.isEmulated,
                  hasSIMCard: operation.device?.hasSIMCard,
                }}
                anonymize={anonymize}
              />
            )}
          </div>
          {(loading || nfcValidationResultObject?.length > 0) && (
            <StatusContainer>
              <StatusCard
                loading={loading}
                type={nfcValidationResult}
                label="NFC_VERIFICATION"
              />
            </StatusContainer>
          )}
        </OperationFaceContent>
      </OperationsCardDevice>
      {checkNfcWidget && (
        <OperationsCardStatus
          loading={loading}
          type={{
            iconColor: 'success400',
            iconName: 'Check',
            backgroundColor: 'success100',
          }}
          label={'NFC'}
        />
      )}
    </OperationsContentDevice>
  );

  return (
    <OperationContainer data-test="operations-id">
      <OperationContentAnonymized>
        {demo && <Anonymized />}
      </OperationContentAnonymized>
      <OperationsTabs
        noPadding
        noBackground
        active={activeTab}
        onChangeActive={(activeTab: string) => setActiveTab(activeTab)}
      >
        <TabPanel name={t('Data')} id="1">
          <OperationsHeaderPanel />

          {noHaveResults ? (
            <OperationsEmptyData
              backRoute={emptyBackRoute}
              backText={emptyBackText}
            />
          ) : (
            <>
              {itemSelected && (
                <ModalOperationsDetail
                  source={itemSelected.url}
                  show={!!itemSelected}
                  mimeType={itemSelected.contentType}
                  title={t(itemSelected.type)}
                  subtitle={`[${getInfoPostion()}]`}
                  onChangeShow={(value) => !value && setPotision(null)}
                  onGoLeft={prev}
                  onGoRight={next}
                  disabledGoLeft={position === 0}
                  disabledGoRight={position === documents.length - 1}
                />
              )}
              <OperationsDataContent>
                {!checkAvailableElements('audio') ? (
                  <OperationsCard
                    title={t('Face verification')}
                    hasError={!isAuthentication && checkLivenessError}
                    loading={loading}
                    dropdown={renderFacialResultListDropdown()}
                  >
                    <OperationFaceContent
                      flexDirection="column"
                      rowGap="0.8"
                      disabled={anonymized}
                    >
                      {!noFacialValidationData ? (
                        <>
                          {(loading || operation.facialAuthenticateResult) && (
                            <SelfieValidations
                              loading={loading}
                              assets={ocrData?.documentImages}
                              state={facialAuthenticateResult}
                              family={operation.family}
                            />
                          )}
                          {(loading || operation.facialLivenessResult) && (
                            <StatusCard
                              loading={loading}
                              type={livenessResult}
                              label="Liveness passive"
                            />
                          )}
                          {(loading || spoofingResultObject?.length > 0) && (
                            <StatusCard
                              loading={loading}
                              type={spoofingResult}
                              label="Injection Attack Detection"
                            />
                          )}
                        </>
                      ) : (
                        <NoFilesUploaded locale={language} />
                      )}
                    </OperationFaceContent>
                  </OperationsCard>
                ) : (
                  <OperationsCard
                    title={t('Voice verification')}
                    hasError={checkLivenessError && checkLivenessData}
                    loading={loading}
                  >
                    <OperationFaceContent
                      flexDirection="column"
                      rowGap="0.8"
                      disabled={anonymized}
                    >
                      {operation?.assets.length > 0 ? (
                        operation?.assets.length === 1 ? (
                          <>
                            <VoiceValidation
                              loading={loading}
                              assets={operation?.assets}
                              status={operation?.status}
                            />
                          </>
                        ) : (
                          <OperationsDocumentCard
                            disabled={anonymized}
                            rowGap="1"
                          >
                            {loading
                              ? getLoadingDocuments()
                              : getDocuments('audio')}
                          </OperationsDocumentCard>
                        )
                      ) : (
                        <NoFilesUploaded locale={language} />
                      )}
                    </OperationFaceContent>
                  </OperationsCard>
                )}
                {Boolean(
                  operation.fingerprintAuthenticateResultList?.length,
                ) && (
                  <OperationsCard
                    title={t('Fingerprint verification')}
                    hasError={
                      fingerprintAuthenticateResult?.[0]?.authStatus ===
                      FacialAuthenticationStatus.negative
                    }
                    loading={loading}
                    dropdown={renderFingerprintResultListDropdown()}
                  >
                    <OperationFaceContent
                      flexDirection="column"
                      rowGap="0.8"
                      disabled={anonymized}
                    >
                      <FingerprintValidation
                        loading={loading}
                        state={fingerprintAuthenticateResult}
                        family={operation.family}
                      />
                    </OperationFaceContent>
                  </OperationsCard>
                )}
                {!isAuthentication && (
                  <>
                    <OperationsCardFiles
                      title={t('Images')}
                      loading={loading}
                      $isAuthentication={isAuthentication}
                      empty={!checkAvailableElements('image')}
                    >
                      <OperationsDocumentCard disabled={anonymized} rowGap="1">
                        {loading ? getLoadingDocuments() : getImages()}
                      </OperationsDocumentCard>
                    </OperationsCardFiles>
                    <OperationsFilesColumn>
                      {getDocumentsCard()}
                      <OperationsCardDocuments
                        title={t('Videos')}
                        loading={loading}
                      >
                        <OperationsDocumentCard
                          disabled={anonymized}
                          rowGap="1"
                        >
                          {loading
                            ? getLoadingDocuments()
                            : getDocuments('video')}
                        </OperationsDocumentCard>
                      </OperationsCardDocuments>
                      {(loading || documentSidesResultObject?.length > 0) && (
                        <OperationsCardDocuments
                          title={t('Document information')}
                          loading={loading}
                        >
                          <OperationsDocumentCard
                            disabled={anonymized}
                            rowGap="1"
                          >
                            <StatusCard
                              loading={loading}
                              type={documentSidesResult}
                              label="Front and back correspondence"
                            />
                          </OperationsDocumentCard>
                        </OperationsCardDocuments>
                      )}
                    </OperationsFilesColumn>
                    <OperationsCard
                      title={t('Personal information')}
                      loading={loading}
                      icon={null}
                    >
                      {!loading && errorOnPersonalInformation ? (
                        <NoFilesUploaded
                          messageType="information"
                          locale={language}
                        />
                      ) : (
                        <OperationCardElement
                          loading={loading}
                          data={ocrData?.personalInformation}
                          anonymize={anonymize}
                        />
                      )}
                    </OperationsCard>
                  </>
                )}
                {!isAuthentication ? (
                  <>
                    {!operation.fingerprintAuthenticateResultList?.length &&
                      getNationalityCard()}
                    {getDeviceCard()}
                    {Boolean(
                      operation.fingerprintAuthenticateResultList?.length,
                    ) && getNationalityCard()}
                  </>
                ) : (
                  <>
                    {getDocumentsCard()}
                    {getDeviceCard()}
                    {getNationalityCard()}
                  </>
                )}
              </OperationsDataContent>
            </>
          )}
        </TabPanel>

        {showSecurityTab ? (
          <TabPanel
            name={t('Security')}
            id="2"
            testIdTab="security"
            hasError={hasSecurityError}
          >
            <OperationsHeaderPanel />
            {operation?.securityList && operation?.securityList?.length > 0 && (
              <OperationsSecurityTab>
                {operation?.securityList
                  ?.filter(
                    (element: any) => element.mode !== 'GOVERNMENTAL_MATCHING',
                  )
                  .map((element: any, index: number) => (
                    <OperationsCard
                      key={index}
                      title={t(element.mode)}
                      loading={loading}
                      icon={
                        element.succeed ? (
                          <OperationsCardIcon $bgColor={'success400'}>
                            <Icon iconName="Check" size="16" color="white" />
                          </OperationsCardIcon>
                        ) : (
                          <OperationsCardIcon $bgColor={'error400'}>
                            <Icon iconName="X" size="16" color="white" />
                          </OperationsCardIcon>
                        )
                      }
                    >
                      <OperationCardElement
                        loading={loading}
                        data={element.data}
                      />
                    </OperationsCard>
                  ))}
              </OperationsSecurityTab>
            )}
            {!loading &&
              (!operation?.securityList ||
                operation?.securityList.length < 1) && (
                <OperationsEmptyData
                  backRoute={emptyBackRoute}
                  backText={emptyBackText}
                />
              )}
          </TabPanel>
        ) : (
          <></>
        )}

        {isAuthentication ? (
          <></>
        ) : (
          <TabPanel name={'OCR'} id="3" testIdTab="ocr">
            <OperationsHeaderPanel />
            {loading || ocrData.source ? (
              <OperationsTabsContent
                flexDirection="column"
                columnGap="2"
                rowGap="2"
              >
                {!!otherTypesOCR?.length && (
                  <FlexContainer>
                    <Dropdown
                      onChange={(source: string[]) => setOcrActive(source)}
                      options={ocrDropdown}
                      label={t('OCR')}
                      placeholder={t('Select OCR')}
                      value={ocrActive}
                      multiple
                      tagPosition="right"
                    />
                  </FlexContainer>
                )}
                {ocrDetailData?.dataSerialized &&
                (!ocrActive || ocrActive.length < 1) ? (
                  <OcrDetail data={ocrDetailData}></OcrDetail>
                ) : (
                  <OperationCardOCR>
                    {listOcrElements()
                      .filter((item) => item)
                      .map((ocr, index) => (
                        <OperationsCard
                          key={index}
                          title={ocr?.source}
                          loading={loading}
                        >
                          <OperationCardElement
                            loading={loading}
                            data={(ocr?.documentDataFields || []).reduce(
                              (obj, item) =>
                                Object.assign(obj, { [item.key]: item.value }),
                              {},
                            )}
                            anonymize={anonymize}
                          />
                        </OperationsCard>
                      ))}
                  </OperationCardOCR>
                )}
              </OperationsTabsContent>
            ) : (
              <OperationsEmptyData
                backRoute={emptyBackRoute}
                backText={emptyBackText}
              />
            )}
          </TabPanel>
        )}

        <TabPanel
          name={t('Timeline')}
          id="4"
          testIdTab="timeline"
          hasError={!!logError.length}
        >
          <OperationsHeaderPanel />
          <OperationTimelineWrapper columnGap="4">
            <OperationCardTimeline disabled={anonymized} flex="0.3">
              <CardBaseHeader>
                <Label semibold>{t('Operation timeline')}</Label>
              </CardBaseHeader>
              <OperationTimeline
                onboardingId={id}
                disabled={anonymized}
                family={operation.family}
              />
            </OperationCardTimeline>
            {!!logError.length && (
              <CardBase flexDirection="column" rowGap="2.4" flex="1">
                <CardBaseHeader>
                  <Label semibold>{t('Error detail')}</Label>
                </CardBaseHeader>
                {logError
                  .filter(
                    (item) =>
                      !ignoredValidations.includes(item?.mode as string),
                  )
                  .map((log, index) => (
                    <DetailError
                      key={index}
                      error={log.reason || OperationReasons.securityError}
                      decision={log.decision ? log.decision : undefined}
                      mode={log.mode ? log.mode : undefined}
                    />
                  ))}
              </CardBase>
            )}
          </OperationTimelineWrapper>
        </TabPanel>

        {hideBehaviour || !hasBehaviourPermission || isAuthentication ? (
          <></>
        ) : (
          <TabPanel name={t('Behaviour')} id="5" testIdTab="behaviour">
            <OperationsHeaderPanel />
            {behaviourEmpty ? (
              <OperationsEmptyData
                backRoute={emptyBackRoute}
                backText={emptyBackText}
              />
            ) : (
              <div style={{ padding: '1.3rem 0', height: '100%' }}>
                <BehaviourProvider
                  language={i18n.language}
                  companyId="Facephi-demo"
                  apiUrl={apiUrl}
                  token={token}
                >
                  <OperationDetail
                    operationId={id}
                    onEmptyData={() => setBehaviourEmpty(true)}
                    onExceptionError={() => setBehaviourEmpty(true)}
                  />
                </BehaviourProvider>
              </div>
            )}
          </TabPanel>
        )}

        <TabPanel
          name={t('Facial attributes')}
          id="6"
          testIdTab="facial-attributes"
          hasError={false}
        >
          <OperationsHeaderPanel />
          {!!facialDetailsData[0]?.characteristics &&
            Object.keys(facialDetailsData[0]?.characteristics).length > 0 && (
              <OperationFacialDetailsWrapper columnGap="6">
                <OperationCardFacialData disabled={anonymized} flex="0.3">
                  <CardBaseHeader>
                    <Label semibold>{t('Selfie')}</Label>
                  </CardBaseHeader>
                  <OperationSelfieCardElement
                    loading={loading}
                    data={facialDetailsPersonalData}
                    anonymize={anonymize}
                    image={
                      facialDetailsData.length > 0
                        ? facialDetailsData[0]
                        : undefined
                    }
                  />
                </OperationCardFacialData>
                {!!Object.keys(facialDetailsData[0]?.characteristics)
                  .length && (
                  <CardBase flexDirection="column" rowGap="2.4" flex="1">
                    <CardBaseHeader>
                      <Label semibold>{t('Facial extraction result')}</Label>
                    </CardBaseHeader>
                    {Object.entries(facialDetailsData[0]?.characteristics).map(
                      ([key, value], index: any) =>
                        !facialBlackList.includes(key) && (
                          <DetailFacial
                            key={index}
                            name={key}
                            result={value as string}
                          />
                        ),
                    )}
                  </CardBase>
                )}
              </OperationFacialDetailsWrapper>
            )}
          {!loading &&
            (!facialDetailsData[0]?.characteristics ||
              Object.keys(facialDetailsData[0]?.characteristics).length <
                1) && (
              <OperationsEmptyData
                backRoute={emptyBackRoute}
                backText={emptyBackText}
              />
            )}
        </TabPanel>

        {!haveReviewTab || operationInProgress ? (
          <></>
        ) : (
          <TabPanel name={t('Review')} id="7" testIdTab="review">
            <OperationsHeaderPanel />
            <ReviewsDataContent>
              <ReviewCard title={t('Check information')}>
                <ReviewForm />
              </ReviewCard>
              <ReviewCard title={t('Timeline')}>
                <ReviewTimeline />
              </ReviewCard>
            </ReviewsDataContent>
          </TabPanel>
        )}
      </OperationsTabs>
    </OperationContainer>
  );
};
